import React from 'react';

import Option from './Option';

export default function Options({ onClick, options = [], selected }) {
  return (
    <div style={{ marginTop: 56 }}>
      {options.map(({ uuid: optionId, value }, index) => (
        <Option
          key={optionId}
          name={optionId}
          index={index}
          text={value}
          checked={selected === optionId}
          onClick={onClick}
        />
      ))}

      <Option
        key="skip"
        name="skip"
        index={options.length}
        text="I don't know"
        checked={selected === 'skip'}
        onClick={onClick}
      />
    </div>
  );
}
